import React, { Component } from 'react'
import { setHeader } from '@/util/set-header'
import { fetchStoreList as fetchStoreListApi } from '@/api/book'
import { ListView, Checkbox, Toast } from 'antd-mobile'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import './index.less'

interface Props {
  location: H.Location
  history: H.History
}

interface State {
  stores: any[]
  id: string
  dataSource: any
}

@(withRouter as any)
export default class SelectStore extends Component<Props, State> {
  el!: ListView
  height: number = 0
  sectionIDs: any = []
  rowIDs: any = []
  dataBlobs: any = {}
  state = {
    id: '',
    stores: [],
    dataSource: new ListView.DataSource({
      getRowData: (dataBlob: any, _: string, rowID: string) => dataBlob[rowID],
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    }),
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '选择门店' })
    Toast.loading('加载中', 0)
  }
  componentDidMount() {
    this.height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.el) as HTMLElement).offsetTop
    window.locationBack = this.locationBack
    if (window.WebViewBridge) {
      window.WebViewBridge?.getLocation?.call(window.WebViewBridge, 'locationBack')
    } else if (window.webkit) {
      window.webkit.messageHandlers.getLocation.postMessage('locationBack')
    }
    
    //this.locationBack(JSON.stringify({ lng: 121.423616, lat: 31.183851 }))

    const { location } = this.props

    const params = new URLSearchParams(location.search)
    const id = params.get('id')
    if (id) {
      this.setState({ id })
    }
  }

  locationBack = (argument?: any) => {
    if (typeof(argument) === 'string') {
      argument = JSON.parse(argument)
      let lat = argument['lat']
      let lng = argument['lng']
      this.getStores({ lat, lng })
    } else {
      let lat = argument['lat']
      let lng = argument['lng']
      this.getStores({ lat, lng })
    }
  }

  getStores = async (params: Object) => {
    const { data, code, msg } = await fetchStoreListApi(params)
    if (code !== 'SUCCESS') {
      Toast.fail(msg)
      return
    }
    Toast.hide()
    const stores = data
    for (let i = 0; i < stores.length; i++) {
      const store = stores[i].list
      const name = stores[i].name
      if (this.sectionIDs.includes(name)) {
        continue
      }
      this.sectionIDs.push(name)
      this.rowIDs[i] = []

      for (let j = 0; j < store.length; j++) {
        const { id } = store[j]
        this.rowIDs[i].push(id)
        this.dataBlobs[id] = store[j]
      }
    }
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        this.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
    })
  }
  store = (store: any) => {
    const { id } = this.state
    return (
      <div className="store" onClick={() => this.storeClick(store)}>
        <div className="radio-wrap">
          <Checkbox checked={id === store.id} />
        </div>
        <div className="info-wrap">
          <span className="title">{store.name}</span>
          <div className="tag-wrap">
            {store.tag &&
              store.tag.map((t: string) =>
                t ? (
                  <span key={t} className="tag font-8">
                    {t}
                  </span>
                ) : (
                    ''
                  ),
              )}
          </div>
          <span className="address font-8">地址：{store.address}</span>
          <span className="distance font-8">
            <img src="/public/assets/img/title_location_icon.png" alt="" />
            {store.distance}
          </span>
        </div>
        <div className="price-wrap">
          <span className="price font-7">{store.price}/元/天/床</span>
        </div>
      </div>
    )
  }
  storeClick = ({ id, name }: any) => {
    const { history } = this.props
    history.push(`/book/booking?id=${id}&name=${name}`)
  }
  render() {
    const { height } = this
    const { dataSource } = this.state
    const separator = (sectionID: any, rowID: any) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 1,
          borderTop: '0.5px solid #ECECED',
          borderBottom: '0.5px solid #ECECED',
        }}
      />
    )
    return (
      <div className="book-select-store">
        <ListView
          ref={el => (this.el = el as ListView)}
          className="stores"
          dataSource={dataSource}
          renderRow={this.store}
          renderSeparator={separator}
          renderSectionHeader={(_, sectionID) => {
            return <div className="stores-title">{sectionID}</div>
          }}
          initialListSize={Object.keys(this.dataBlobs).length}
          style={{
            height,
            overflow: 'auto',
          }}
        />
      </div>
    )
  }
}
